<template>
  <div class="pics">
    <v-pics-compo
      :firstImg="imgCompo.img1"
      :secondImg="imgCompo.img2"
      :thirdImg="imgCompo.img3"
      @imageIndx="imageClicked"
    ></v-pics-compo>

    <!-- LIGHT-BOX -->
    <v-light-box
      :showLightbox="lightbox"
      @hideLightbox="lightbox = false"
      :images="lightboxPicsCompo"
      :startAt="lightboxIdx"
    ></v-light-box>
  </div>
</template>

<script>
import VPicsCompo from '@/components/atomic/VPicsCompo.vue';
import VLightBox from '@/components/atomic/VLightBox.vue';

export default {
  name: 'HomePicsCompo',
  components: {
    VPicsCompo,
    VLightBox,
  },
  data() {
    return {
      lightbox: false,
      lightboxIdx: 0,
      imgCompo: {
        img1: {
          url:
            'https://res.cloudinary.com/elenaproject/image/upload/e_auto_color,e_auto_saturation,e_auto_brightness,e_auto_contrast,c_scale,q_auto:best,w_300/v1603912715/outdoor-areas/rizes-house_outdoor-area_11_zvbwl5.jpg',
          alt: 'rizes-house',
        },

        img2: {
          url:
            'https://res.cloudinary.com/elenaproject/image/upload/e_auto_color,e_auto_saturation,e_auto_brightness,e_auto_contrast,c_scale,q_auto:best,w_300/v1597072183/outdoor-areas/rizes-house_outdoor-area_0_ctpszt.jpg',
          alt: 'agios nikolaos',
        },
        img3: {
          url:
            'https://res.cloudinary.com/elenaproject/image/upload/e_auto_color,e_auto_saturation,e_auto_brightness,e_auto_contrast,c_scale,q_auto:best,w_300/v1597072182/outdoor-areas/rizes-house_outdoor-area_5_ryzwfe.jpg',
          alt: 'rizes-house',
        },
      },
      lightboxPicsCompo: [
        'https://res.cloudinary.com/elenaproject/image/upload/e_auto_color,e_auto_saturation,e_auto_brightness,e_auto_contrast,c_scale,q_auto:best,w_600/v1603912715/outdoor-areas/rizes-house_outdoor-area_11_zvbwl5.jpg',
        'https://res.cloudinary.com/elenaproject/image/upload/e_auto_color,e_auto_saturation,e_auto_brightness,e_auto_contrast,c_scale,q_auto:best,w_600/v1597072183/outdoor-areas/rizes-house_outdoor-area_0_ctpszt.jpg',
        'https://res.cloudinary.com/elenaproject/image/upload/e_auto_color,e_auto_saturation,e_auto_brightness,e_auto_contrast,c_scale,q_auto:best,w_600/v1597072182/outdoor-areas/rizes-house_outdoor-area_5_ryzwfe.jpg',
      ],
    };
  },
  methods: {
    imageClicked(idx) {
      this.lightbox = true;
      this.lightboxIdx = idx;
    },
  },
};
</script>

<style scoped lang="scss">
.pics {
  display: flex;
  align-items: center;
  justify-content: center;
}
</style>
